'use client';

import { AnimatePresence, motion } from 'motion/react';

import { cn } from '../utils/cn';
import { Progress } from './progress';

export type LoadingOverlayProps = {
  open: boolean;
  /** App-owned brand mark (e.g. `/assets/images/brand/logo-white.svg`). */
  logoSrc: string;
  logoAlt?: string;
  className?: string;
  onExitComplete?: () => void;
};

/**
 * Full-screen loading splash (setup/admin shared).
 * Theme-aware logo via CSS filters on a light/white asset.
 * Wire `open` from app state; keep store debounce in the consumer.
 */
export function LoadingOverlay({
  open,
  logoSrc,
  logoAlt = 'up2promo',
  className,
  onExitComplete,
}: LoadingOverlayProps) {
  return (
    <AnimatePresence mode="wait" onExitComplete={onExitComplete}>
      {open ? (
        <motion.div
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className={cn(
            'fixed inset-0 z-[10000] flex items-center justify-center bg-background',
            className,
          )}
        >
          <div className="flex w-full flex-col items-center gap-5">
            <img
              className="h-24 object-contain brightness-0 dark:brightness-100"
              alt={logoAlt}
              src={logoSrc}
            />
            <div className="w-full max-w-sm p-12">
              <Progress className="h-2 bg-muted" isIndeterminate />
            </div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
